import React, { useState } from "react";
import "./Dashboard.css";
import AddRenewPolicy from "../RenewPolicy/AddRenewPolicy";
import RenewPolicy from "../RenewPolicy/RenewPolicy";
import PolicyList from "../PolicyList/PolicyList";
import { NavLink } from "react-router-dom";

const DashBoard = ({ Islogout }) => {
    const [policyList, setPolicyList] = useState([]);
    const [loading, setLoading] = useState(true);  // New loading state

    const getPolicyList = (data) => {
        setPolicyList(data);
    };

    const handleLoading = (isLoading) => {
        setLoading(isLoading);
    };

    const currentDate = new Date();
    const getDaysDifference = (endDate) => {
        let daysDifference = 0;
        if (endDate !== "" && endDate !== null && endDate !== undefined) {
            const policyEndDate = new Date(endDate?.split("/")?.reverse()?.join("/")); // Convert "dd/MM/yyyy" to "yyyy/MM/dd"
            const timeDifference = policyEndDate - currentDate;
            daysDifference = Math.ceil(timeDifference / (1000 * 60 * 60 * 24)); // Convert milliseconds to days
        }
        return daysDifference;
    };

    return (
        <>
            <div className="row">
                <div className="col-md-8">
                    {loading ? (
                        // Show loader when loading
                        <div className="ProductLoader">
                        </div>

                    ) : policyList && policyList.length > 0 ? (
                        (() => {
                            const filteredPolicies = policyList
                                .filter((item) => {
                                    const daysDiff = getDaysDifference(item.PolicyEndDate);
                                    return daysDiff > 0 && daysDiff < 90;
                                })
                                .map((item, index) =>
                                    !item.IsExternal ? <RenewPolicy key={item.id || index} policyList={item} /> : null
                                )
                                .filter(Boolean); // Remove null values

                            return filteredPolicies.length > 0 ? (
                                filteredPolicies
                            ) : (
                                <div className="alert alert-danger" role="alert">
                                    <i className="fas fa-exclamation-triangle"></i> You have no upcoming renewal policy upon purchase by SMC
                                </div>
                            );
                        })()
                    ) : (
                        <div className="alert alert-danger" role="alert">
                            <i className="fas fa-exclamation-triangle"></i> No policies available.
                        </div>
                    )}
                </div>

                <div className="col-md-4">
                    <NavLink to="/policy-sync">
                        <AddRenewPolicy />
                    </NavLink>
                </div>
            </div>
            <div className="mt-4">
                <h4>
                    My policies ({policyList?.length > 0 ? policyList?.length : "0"})
                </h4>
                <PolicyList
                    RedirectTo={"/policy-details"}
                    onSendData={getPolicyList}
                    onLoading={handleLoading}  // Send loading state function to child
                />
            </div>
        </>
    );
};

export default DashBoard;
